// Detail článku (body.type-post) a pojmu ze Slovníku pojmů (body.type-glossary, nativní doplněk
// i stará blogová rubrika) — knihovna prvků článku a vysvětlivky slovníčku.
// Texty a přepínače: shopDataLayer.blogArticle. Vše je idempotentní — běží při ready
// i po každém ShoptetDOMContentLoaded a nic nezdvojí.

// Stažené stránky (produkty, pojmy) — jeden request na URL, i když je URL v článku vícekrát
const blogArticlePageCache = {};
let blogArticleFaqCounter = 0;
let blogArticleResizeTimer = null;

function getBlogArticleSettings() {
    return window.shopDataLayer && window.shopDataLayer.blogArticle ? window.shopDataLayer.blogArticle : null;
}

// Vrátí jen cestu na vlastní doméně (cizí URL se nestahují)
function getBlogArticleLocalPath(url) {
    const link = document.createElement("a");
    link.href = $.trim(url);

    if (!link.pathname || link.hostname.replace(/^www\./, "") !== window.location.hostname.replace(/^www\./, "")) {
        return null;
    }

    return link.pathname;
}

// Stáhne stránku a vrátí dokument, ve kterém se nenačítají obrázky ani skripty
function fetchBlogArticlePage(path) {
    if (!blogArticlePageCache[path]) {
        const deferred = $.Deferred();

        $.get(path, function (data) {
            const doc = new DOMParser().parseFromString(data, "text/html");
            deferred.resolve($(doc), data);
        }, "html").fail(function () {
            deferred.reject();
        });

        blogArticlePageCache[path] = deferred.promise();
    }

    return blogArticlePageCache[path];
}

// Obsah článku, nebo celý detail pojmu nativního Slovníku pojmů (obsah z editoru je přímo v article)
function getBlogArticleText() {
    return $(".type-post .news-item-detail .text, .type-glossary .glossaryDetail");
}

function escapeBlogArticleText(text) {
    return $("<div></div>").text(text).html();
}

// ---------------------------------------------------------------------------
// Produktová karta z URL
// ---------------------------------------------------------------------------

function parseBlogArticleProduct($doc, raw, path) {
    const $form = $doc.find("#product-detail-form");
    const name = $.trim($doc.find(".p-detail-inner-header h1, #content h1").first().text());

    if (!$doc.find("body.type-detail").length || !name) {
        return null;
    }

    const settings = getBlogArticleSettings();
    const hiddenFlags = settings && settings.products ? settings.products.hiddenFlags : [];
    const hasVariants = /"hasVariants":\s*true/.test(raw);
    const image = $doc.find("meta[property='og:image']").attr("content") || "";

    // U variant jsou dostupnosti per varianta — bere se první skladová, jinak první
    const $availabilityValue = $doc.find(".availability-value").first();
    let $availability = $availabilityValue.children(".parameter-dependent").filter(function () {
        return $(this).find(".availability-amount").length > 0;
    }).first();

    if (!$availability.length) {
        $availability = $availabilityValue.children(".parameter-dependent").first();
    }
    if (!$availability.length) {
        $availability = $availabilityValue;
    }

    const $label = $availability.find(".availability-label").first();
    const $flags = $doc.find(".p-image-wrapper .flags-default .flag").filter(function () {
        const flag = this;
        return !hiddenFlags.some(function (className) {
            return $(flag).hasClass(className);
        });
    });

    return {
        url: path,
        name: name,
        image: window.myImageSize ? window.myImageSize(image, "detail") : image,
        productId: $form.find("input[name='productId']").val(),
        priceId: $form.find("input[name='priceId']").val(),
        hasVariants: hasVariants,
        // Nekoupitelný produkt (vyprodaný, na dotaz) nemá na detailu tlačítko do košíku
        purchasable: $form.find(".add-to-cart-button").length > 0,
        price: getBlogArticlePrice($doc.find(".p-final-price-wrapper .price-final")),
        priceStandard: getBlogArticlePrice($doc.find(".p-final-price-wrapper .price-standard")),
        availabilityText: $.trim($label.find(".show-tooltip").first().text() || $label.text()),
        availabilityTitle: $label.find(".show-tooltip").first().attr("title") || "",
        availabilityColor: ($label.attr("style") || "").replace(/^\s*color:\s*/, "").replace(/;\s*$/, ""),
        availabilityAmount: $.trim($availability.find(".availability-amount").first().text()),
        flags: $flags.map(function () {
            return this.outerHTML;
        }).get().join(""),
    };
}

// U variant drží Shoptet cenu pro každou variantu zvlášť — bere se souhrnná „od …" (.default-variant)
function getBlogArticlePrice($price) {
    const $default = $price.find(".default-variant").first();
    const $source = $default.length ? $default : $price.find(".price-final-holder").first();

    return $.trim(($source.length ? $source : $price.first()).text()).replace(/\s+/g, " ");
}

function buildBlogArticleProductCard(product) {
    const language = typeof getShoptetDataLayer === "function" ? getShoptetDataLayer().language : "cs";
    let tools = "";

    if (product.hasVariants || !product.purchasable || !product.price || !product.priceId || !product.productId) {
        tools = "<a href='" + product.url + "' class='btn btn-primary'>" + window.shopDataLayer.product.detailButton + "</a>";
    } else {
        tools = "<form action='/action/Cart/addCartItem/' method='post' class='pr-action csrf-enabled'>" +
            "<input type='hidden' name='language' value='" + language + "'>" +
            "<input type='hidden' name='priceId' value='" + product.priceId + "'>" +
            "<input type='hidden' name='productId' value='" + product.productId + "'>" +
            "<input type='hidden' name='amount' value='1' autocomplete='off'>" +
            "<button type='submit' class='btn btn-cart add-to-cart-button'>" + window.shopDataLayer.product.addToCartButton + "</button>" +
        "</form>";
    }

    return "<div class='product'>" +
        "<div class='p' data-micro-product-id='" + product.productId + "'>" +
            "<a href='" + product.url + "' class='image'>" +
                "<img src='" + product.image + "' alt='" + escapeBlogArticleText(product.name) + "' width='423' height='423' loading='lazy'>" +
                "<div class='flags flags-default'>" + product.flags + "</div>" +
            "</a>" +
            "<div class='p-in'>" +
                "<div class='p-in-in'>" +
                    "<a href='" + product.url + "' class='name'><span>" + escapeBlogArticleText(product.name) + "</span></a>" +
                    "<div class='ratings-wrapper'>" +
                        "<div class='availability'>" +
                            "<span class='show-tooltip' title='" + escapeBlogArticleText(product.availabilityTitle) + "' style='color:" + escapeBlogArticleText(product.availabilityColor) + "'>" + escapeBlogArticleText(product.availabilityText) + "</span>" +
                            (product.availabilityAmount ? " <span class='availability-amount'>" + escapeBlogArticleText(product.availabilityAmount) + "</span>" : "") +
                        "</div>" +
                    "</div>" +
                "</div>" +
                "<div class='p-bottom single-button'>" +
                    "<div>" +
                        "<div class='prices'>" +
                            (product.priceStandard ? "<span class='price-standard'><span>" + escapeBlogArticleText(product.priceStandard) + "</span></span>" : "") +
                            (product.price ? "<div class='price price-final'><strong>" + escapeBlogArticleText(product.price) + "</strong></div>" : "") +
                        "</div>" +
                        "<div class='p-tools'>" + tools + "</div>" +
                    "</div>" +
                "</div>" +
            "</div>" +
        "</div>" +
    "</div>";
}

function initBlogArticleProducts($scope) {
    $scope.find(".myarticle-products").not("[data-myarticle-done]").each(function () {
        const $block = $(this).attr("data-myarticle-done", "1");
        const urls = ($block.attr("data-url") || "").split(/[\s,]+/);
        const paths = [];

        $block.find("[data-url]").each(function () {
            urls.push($(this).attr("data-url"));
        });

        urls.forEach(function (url) {
            const path = url ? getBlogArticleLocalPath(url) : null;
            if (path && paths.indexOf(path) === -1 && paths.length < 4) {
                paths.push(path);
            }
        });

        if (!paths.length) {
            $block.addClass("is-empty");
            return;
        }

        $block.addClass("is-loading");

        const requests = paths.map(function (path) {
            const result = $.Deferred();

            fetchBlogArticlePage(path).then(function ($doc, raw) {
                result.resolve(parseBlogArticleProduct($doc, raw, path));
            }, function () {
                result.resolve(null);
            });

            return result.promise();
        });

        $.when.apply($, requests).then(function () {
            const products = Array.prototype.slice.call(arguments).filter(Boolean);

            $block.removeClass("is-loading");

            if (!products.length) {
                $block.addClass("is-empty").empty();
                return;
            }

            const $list = $("<div class='myarticle-products-list products-block products'></div>");

            products.forEach(function (product) {
                $list.append(buildBlogArticleProductCard(product));
            });

            $block
                .empty()
                .toggleClass("myarticle-products--single", products.length === 1)
                .append($list);

            if (typeof window.initProductCards === "function") {
                window.initProductCards($list);
            }

            if (typeof window.initTooltips === "function") {
                window.initTooltips();
            }
        });
    });
}

// ---------------------------------------------------------------------------
// Karta pojmu ze slovníčku
// ---------------------------------------------------------------------------

function initBlogArticleTerms($scope, settings) {
    $scope.find(".myarticle-term").not("[data-myarticle-done]").each(function () {
        const $block = $(this).attr("data-myarticle-done", "1");
        const path = getBlogArticleLocalPath($block.attr("data-url") || "");

        if (!path) {
            $block.addClass("is-empty");
            return;
        }

        $block.addClass("is-loading");

        fetchBlogArticlePage(path).then(function ($doc) {
            // Nativní detail pojmu (.glossaryDetail) i článek staré blogové rubriky
            const title = $.trim($doc.find(".glossaryDetail > h1, .news-item-detail h1").first().text());
            const perex = $doc.find(".glossaryDetail p, .news-item-detail .text p").filter(function () {
                const $paragraph = $(this);

                return !$paragraph.is(".myglossary-image") &&
                    !$paragraph.closest(".dmproducts, .myarticle-toc, .myarticle-summary, .myarticle-box, .myarticle-proscons, .myarticle-faq, .myarticle-cta, .myarticle-author, .myarticle-term, .myarticle-products").length &&
                    $.trim($paragraph.text()).length > 60;
            }).first();

            $block.removeClass("is-loading");

            if (!title) {
                $block.addClass("is-empty").empty();
                return;
            }

            $block.html(
                "<div class='myarticle-term-content'>" +
                    "<p class='myarticle-term-label'>" + settings.term.label + "</p>" +
                    "<p class='myarticle-term-title'><a href='" + path + "'>" + escapeBlogArticleText(title) + "</a></p>" +
                    (perex.length ? "<p class='myarticle-term-text'>" + escapeBlogArticleText($.trim(perex.text())) + "</p>" : "") +
                    "<a href='" + path + "' class='myarticle-term-button'>" + settings.term.buttonText + "</a>" +
                "</div>"
            );
        }, function () {
            $block.removeClass("is-loading").addClass("is-empty").empty();
        });
    });
}

// ---------------------------------------------------------------------------
// Obsah článku (TOC) z nadpisů h2
// ---------------------------------------------------------------------------

function createBlogArticleSlug(text, usedIds) {
    let slug = text.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") || "kapitola";
    let candidate = slug;
    let index = 2;

    while (usedIds.indexOf(candidate) !== -1 || document.getElementById(candidate)) {
        candidate = slug + "-" + index;
        index++;
    }

    usedIds.push(candidate);
    return candidate;
}

function initBlogArticleToc($text, settings) {
    const $toc = $text.find(".myarticle-toc").not("[data-myarticle-done]").first();

    if (!$toc.length) {
        return;
    }

    $toc.attr("data-myarticle-done", "1");

    // Nadpisy uvnitř speciálních bloků (FAQ, box…) do obsahu nepatří
    const $headings = $text.find("h2").filter(function () {
        return !$(this).closest(".myarticle-toc, .myarticle-summary, .myarticle-box, .myarticle-proscons, .myarticle-faq, .myarticle-cta, .myarticle-author").length && $.trim($(this).text()).length > 0;
    });

    if ($headings.length < settings.toc.minHeadings) {
        $toc.addClass("is-empty").empty();
        return;
    }

    const usedIds = [];
    const $list = $("<ol class='myarticle-toc-list'></ol>");

    $headings.each(function () {
        const $heading = $(this);
        const text = $.trim($heading.text());

        if (!$heading.attr("id")) {
            $heading.attr("id", createBlogArticleSlug(text, usedIds));
        }

        $("<li></li>").append(
            $("<a class='myarticle-toc-link'></a>").attr("href", "#" + $heading.attr("id")).text(text)
        ).appendTo($list);
    });

    $toc.empty()
        .append("<p class='myarticle-toc-title'>" + settings.toc.title + "</p>")
        .append($list)
        .toggleClass("myarticle-toc--columns", $headings.length > 5);
}

// Výška pevné hlavičky, která by nadpis po skoku zakryla
function getBlogArticleHeaderOffset() {
    let offset = 0;

    $("#header, .top-navigation-bar, .header-top-wrapper, .site-msg").each(function () {
        const position = $(this).css("position");
        const rect = this.getBoundingClientRect();

        // Počítá se celá výška i u hlavičky, která se při rolování dolů schová a nahoru zase ukáže
        if ((position === "fixed" || position === "sticky") && rect.top <= 1) {
            offset = Math.max(offset, Math.max(0, rect.top) + this.offsetHeight);
        }
    });

    return offset + 20;
}

function scrollBlogArticleToHeading($heading) {
    const target = function () {
        return $heading.offset().top - getBlogArticleHeaderOffset();
    };

    window.scrollTo({ top: target(), behavior: "smooth" });

    // Hlavička se může po odrolování přepnout na pevnou — po doběhnutí se pozice dorovná
    setTimeout(function () {
        const correction = $heading[0].getBoundingClientRect().top - getBlogArticleHeaderOffset();

        if (Math.abs(correction) > 2) {
            window.scrollTo({ top: window.pageYOffset + correction, behavior: "auto" });
        }
    }, 900);
}

$(document).on("click", ".myarticle-toc-link", function (e) {
    const $heading = $($(this).attr("href"));

    if (!$heading.length) {
        return;
    }

    e.preventDefault();

    if (window.history && window.history.replaceState) {
        window.history.replaceState(null, "", $(this).attr("href"));
    }

    scrollBlogArticleToHeading($heading);
});

// ---------------------------------------------------------------------------
// FAQ akordeon
// ---------------------------------------------------------------------------

function initBlogArticleFaq($text, settings) {
    const faqSchema = [];

    $text.find(".myarticle-faq").not("[data-myarticle-done]").each(function () {
        const $faq = $(this).attr("data-myarticle-done", "1");
        const faqIndex = blogArticleFaqCounter++;

        $faq.find(".myarticle-faq-item").each(function (itemIndex) {
            const $item = $(this);
            const $question = $item.find(".myarticle-faq-question").first();
            const $answer = $item.find(".myarticle-faq-answer").first();
            const answerId = "myarticle-faq-" + faqIndex + "-" + itemIndex;

            if (!$question.length || !$answer.length) {
                return;
            }

            faqSchema.push({
                "@type": "Question",
                name: $.trim($question.text()),
                acceptedAnswer: {
                    "@type": "Answer",
                    text: $.trim($answer.text()),
                },
            });

            $answer.attr("id", answerId).hide();
            $question.wrapInner("<button type='button' class='myarticle-faq-button' aria-expanded='false' aria-controls='" + answerId + "'></button>");
        });

        $faq.addClass("is-ready");
    });

    if (faqSchema.length && settings.faq.structuredData && !$("#myarticle-faq-schema").length) {
        $("<script type='application/ld+json' id='myarticle-faq-schema'></script>")
            .text(JSON.stringify({
                "@context": "https://schema.org",
                "@type": "FAQPage",
                mainEntity: faqSchema,
            }))
            .appendTo("head");
    }
}

$(document).on("click", ".myarticle-faq-button", function () {
    const $button = $(this);
    const $item = $button.closest(".myarticle-faq-item");
    const $answer = $("#" + $button.attr("aria-controls"));

    if ($item.hasClass("is-open")) {
        $button.attr("aria-expanded", "false");
        $answer.slideUp(250, function () {
            $item.removeClass("is-open");
        });
    } else {
        $item.addClass("is-open");
        $button.attr("aria-expanded", "true");
        $answer.slideDown(250);
    }
});

// ---------------------------------------------------------------------------
// Tabulky, galerie, datum aktualizace
// ---------------------------------------------------------------------------

function initBlogArticleTables($text, settings) {
    // Shoptet sám obaluje široké tabulky do .scroll-wrapper — obal se pak bere i s ním
    $text.find("table").each(function () {
        const $table = $(this);

        if (!$table.closest(".myarticle-table").length) {
            ($table.parent(".scroll-wrapper").length ? $table.parent() : $table).wrap("<div class='myarticle-table'></div>");
        }
    });

    $text.find(".myarticle-table").each(function () {
        const $wrapper = $(this);
        const table = $wrapper.find("table")[0];
        const isScrollable = table ? table.offsetWidth > this.clientWidth + 1 : false;

        $wrapper.toggleClass("is-scrollable", isScrollable);

        if (settings.table.scrollHint && !$wrapper.next(".myarticle-table-hint").length) {
            $("<p class='myarticle-table-hint'></p>").text(settings.table.scrollHint).insertAfter($wrapper);
        }

        $wrapper.next(".myarticle-table-hint").toggleClass("is-visible", isScrollable);
    });
}

function initBlogArticleGalleries($text) {
    if (typeof $.fn.colorbox !== "function") {
        return;
    }

    $text.find(".myarticle-gallery").not("[data-myarticle-done]").each(function (index) {
        $(this).attr("data-myarticle-done", "1").find("a[href]").colorbox({
            rel: "myarticle-gallery-" + index,
            photo: true,
            maxWidth: "95%",
            maxHeight: "95%",
        });
    });
}

function formatBlogArticleDate(isoDate) {
    const parts = isoDate.slice(0, 10).split("-");
    // Stejný formát jako datum článku od Shoptetu („9.4.2026“)
    return parseInt(parts[2], 10) + "." + parseInt(parts[1], 10) + "." + parts[0];
}

// Řádek pod nadpisem: datum zveřejnění · Aktualizováno … · Autor: …
function initBlogArticleMeta($text, settings) {
    const $detail = $(".news-item-detail");
    const $time = $detail.children("time");
    const published = $detail.children("meta[itemprop='datePublished']").attr("content") || "";
    const modified = $detail.children("meta[itemprop='dateModified']").attr("content") || "";
    const updated = settings.updated || {};
    const author = settings.author || {};
    const showUpdated = updated.enabled && modified && modified.slice(0, 10) > published.slice(0, 10);
    const showAuthor = author.enabled && author.name;

    if (!$time.length || $detail.find(".myarticle-meta").length || (!showUpdated && !showAuthor)) {
        return;
    }

    const $meta = $time.wrap("<div class='myarticle-meta'></div>").parent();

    if (showUpdated) {
        $("<span class='myarticle-updated'></span>")
            .text(updated.text + " " + formatBlogArticleDate(modified))
            .appendTo($meta);
    }

    if (showAuthor) {
        // Ruční prvek „Autor (v řádku s datem)“ ve starších článcích — jinak by autor byl dvakrát
        $text.children(".myarticle-author").filter(function () {
            return !$(this).find(".myarticle-author-image, .myarticle-author-role").length;
        }).remove();

        const $author = $("<span class='myarticle-meta-author' itemprop='author' itemscope itemtype='https://schema.org/Person'></span>")
            .text(author.label + " ")
            .appendTo($meta);

        $("<span itemprop='name'></span>").text(author.name).appendTo($author);
    }
}

// ---------------------------------------------------------------------------
// Vysvětlivky ze Slovníku pojmů (nativní doplněk Shoptetu)
// <span class="show-tooltip" title="…"><a class="glossary" href="…">slovo</a></span>
// ---------------------------------------------------------------------------

let glossaryHideTimer = null;

function initGlossaryTerms() {
    // V nadpisech vysvětlivku nechceme — zůstane prostý text
    $("h1, h2, h3, h4, h5, h6").find(".show-tooltip, .myglossary").filter(function () {
        return $(this).children("a.glossary").length > 0;
    }).each(function () {
        $(this).replaceWith(document.createTextNode($(this).text()));
    });

    $(".show-tooltip").filter(function () {
        return $(this).children("a.glossary").length > 0;
    }).each(function () {
        const $term = $(this);
        const text = $term.attr("data-original-title") || $term.attr("title") || "";

        if (typeof $term.tooltip === "function" && $term.data("bs.tooltip")) {
            $term.tooltip("destroy");
        }

        // Bez třídy show-tooltip ho Shoptet při dalším initTooltips() znovu nepřevezme
        $term
            .removeClass("show-tooltip")
            .addClass("myglossary")
            .attr("data-myglossary-text", text)
            .removeAttr("title data-original-title");
    });
}

function getGlossaryPopover() {
    let $popover = $(".myglossary-pop");

    if (!$popover.length) {
        $popover = $("<div class='myglossary-pop' role='tooltip' id='myglossary-pop' hidden>" +
            "<p class='myglossary-pop-text'></p>" +
            "<a class='myglossary-pop-link' href='#'></a>" +
            "<span class='myglossary-pop-arrow'></span>" +
        "</div>").appendTo("body");
    }

    return $popover;
}

function showGlossaryPopover($term) {
    const settings = getBlogArticleSettings();
    const $link = $term.children("a.glossary");
    const $popover = getGlossaryPopover();
    const text = $term.attr("data-myglossary-text");

    if (!text) {
        return;
    }

    clearTimeout(glossaryHideTimer);

    $(".myglossary.is-active").not($term).removeClass("is-active");
    $term.addClass("is-active");

    $popover.find(".myglossary-pop-text").html(text);
    $popover.find(".myglossary-pop-link")
        .attr("href", $link.attr("href"))
        .text(settings ? settings.glossary.linkText : $link.attr("href"));
    $link.attr("aria-describedby", "myglossary-pop");

    $popover.removeAttr("hidden").removeClass("is-below");

    const rect = $link[0].getBoundingClientRect();
    const popoverWidth = $popover.outerWidth();
    const popoverHeight = $popover.outerHeight();
    const viewportWidth = document.documentElement.clientWidth;
    const center = rect.left + rect.width / 2;
    const left = Math.min(Math.max(10, center - popoverWidth / 2), viewportWidth - popoverWidth - 10);
    let top = rect.top + window.pageYOffset - popoverHeight - 12;

    // Nahoře není místo → vysvětlivka pod slovem
    if (rect.top - popoverHeight - 12 < 10) {
        top = rect.bottom + window.pageYOffset + 12;
        $popover.addClass("is-below");
    }

    $popover.css({ top: top, left: left + window.pageXOffset });
    $popover.find(".myglossary-pop-arrow").css("left", center - left);
}

function hideGlossaryPopover(delay) {
    clearTimeout(glossaryHideTimer);

    glossaryHideTimer = setTimeout(function () {
        $(".myglossary.is-active").removeClass("is-active").children("a.glossary").removeAttr("aria-describedby");
        $(".myglossary-pop").attr("hidden", "hidden");
    }, delay || 0);
}

const glossaryCanHover = window.matchMedia && window.matchMedia("(hover: hover)").matches;

if (glossaryCanHover) {
    $(document).on("mouseenter focusin", ".myglossary", function () {
        showGlossaryPopover($(this));
    });

    $(document).on("mouseleave focusout", ".myglossary", function () {
        hideGlossaryPopover(300);
    });

    $(document).on("mouseenter focusin", ".myglossary-pop", function () {
        clearTimeout(glossaryHideTimer);
    });

    $(document).on("mouseleave", ".myglossary-pop", function () {
        hideGlossaryPopover(300);
    });
} else {
    // Dotyk: první klepnutí ukáže vysvětlivku, druhé klepnutí na slovo přejde na pojem
    $(document).on("click", ".myglossary > a.glossary", function (e) {
        const $term = $(this).parent();

        if (!$term.hasClass("is-active")) {
            e.preventDefault();
            showGlossaryPopover($term);
        }
    });

    $(document).on("click touchstart", function (e) {
        if (!$(e.target).closest(".myglossary, .myglossary-pop").length) {
            hideGlossaryPopover(0);
        }
    });
}

$(document).on("keydown", function (e) {
    if (e.key === "Escape" && $(".myglossary.is-active").length) {
        hideGlossaryPopover(0);
    }
});

// Zavírá se jen při změně šířky — na mobilu mění výšku okna i schování adresního řádku při scrollu
let glossaryWindowWidth = window.innerWidth;

$(window).on("resize", function () {
    if (window.innerWidth === glossaryWindowWidth) {
        return;
    }

    glossaryWindowWidth = window.innerWidth;

    if ($(".myglossary.is-active").length) {
        hideGlossaryPopover(0);
    }
});

// ---------------------------------------------------------------------------
// Spuštění
// ---------------------------------------------------------------------------

// Doplněk „blog-products“ (div.dmproducts) vykresluje karty až po načtení stránky a umí je
// překreslit — karty se sjednotí s ostatními (texty tlačítek, zkrácená dostupnost), kdykoliv
// se v nich objeví nativní podoba
function blogArticleDmProductsNeedUpdate($text) {
    const texts = window.shopDataLayer.product;
    const separator = window.shopDataLayer.availability ? window.shopDataLayer.availability.shortSeparator : null;

    return $text.find(".dmproducts .p-tools .btn-primary").filter(function () {
        return $.trim($(this).text()) !== texts.detailButton;
    }).length > 0 || $text.find(".dmproducts .p-tools .add-to-cart-button").filter(function () {
        return $.trim($(this).text()) !== texts.addToCartButton;
    }).length > 0 || (separator && $text.find(".dmproducts .availability > .show-tooltip").filter(function () {
        return $(this).text().indexOf(separator) !== -1;
    }).length > 0);
}

function watchBlogArticleDmProducts($text) {
    // Hlídá se vždy — doplněk bloky při načtení dočasně vyjme a vrací je až po stažení produktů
    if ($text.attr("data-myarticle-dm-watch") || typeof MutationObserver === "undefined" || typeof window.initProductCards !== "function") {
        return;
    }

    let timer = null;
    const update = function () {
        if (blogArticleDmProductsNeedUpdate($text)) {
            window.initProductCards($text.find(".dmproducts"));
        }
    };

    $text.attr("data-myarticle-dm-watch", "1");
    new MutationObserver(function () {
        clearTimeout(timer);
        timer = setTimeout(update, 100);
    }).observe($text[0], { childList: true, subtree: true });
    update();
}

function initBlogArticle() {
    initGlossaryTerms();

    const settings = getBlogArticleSettings();
    const $text = getBlogArticleText();

    if (!settings || !$text.length) {
        return;
    }

    initBlogArticleMeta($text, settings);
    initBlogArticleToc($text, settings);
    initBlogArticleFaq($text, settings);
    initBlogArticleTables($text, settings);
    initBlogArticleGalleries($text);
    initBlogArticleProducts($text);
    initBlogArticleTerms($text, settings);
    watchBlogArticleDmProducts($text);
}

$(document).ready(function () {
    initBlogArticle();
});

document.addEventListener("ShoptetDOMContentLoaded", function () {
    initBlogArticle();
});

let blogArticleWindowWidth = window.innerWidth;

$(window).on("resize", function () {
    const settings = getBlogArticleSettings();
    const $text = getBlogArticleText();

    // Vejde-li se tabulka, závisí jen na šířce
    if (window.innerWidth === blogArticleWindowWidth) {
        return;
    }

    blogArticleWindowWidth = window.innerWidth;
    clearTimeout(blogArticleResizeTimer);

    // Debounce — přepočet, jestli se tabulka vejde
    blogArticleResizeTimer = setTimeout(function () {
        if (settings && $text.length) {
            initBlogArticleTables($text, settings);
        }
    }, 200);
});
